import { Col, Row } from "antd";
import { FormikValues } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ActivityEnum, ActivityStatusEnum } from "../../../enums/activity.enum";
import { UserTypes } from "../../../enums/userTypes.enum";
import { Activity } from "../../../models/activity.model";
import ContainerService from "../../../services/ContainerService/container.service";
import ContainerTableActions from "../../../shared/components/ContainerTableActions";
import TableComponent from "../../../shared/components/TableComponent";
import useFilters from "../../../shared/hooks/useFilters";
import LocalStorage from "../../../shared/LocalStorage";
import { CustomerType } from "../../../enums/customerType";

const columns = [
    {
        title: "Container Number",
        dataIndex: "containerNumber",
        key: "containerNumber",
        width: 100,
    },
    {
        title: "Yard",
        dataIndex: "yardName",
        key: "yardName",
        width: 100,
        sorter: true,
        render: (text: string) => <span className="text-capitalize">{text}</span>,
    },
    {
        title: "Customer",
        dataIndex: "customer",
        key: "customer",
        width: 100,
        sorter: true,
    },
    {
        title: "Owner Name",
        dataIndex: "containerOwnerName",
        key: "containerOwnerName",
        width: 100,
    },
    {
        title: "Current Activity",
        dataIndex: "activityType",
        key: "activityType",
        width: 100,
        sorter: true,
        render: (text: string) => <span className="text-capitalize">{text}</span>,
    },
    {
        title: "Activity Date",
        dataIndex: "activityDate",
        key: "activityDate",
        width: 100,
        sorter: true,
        render: (text: string) => <span>{text ? moment(text).format("DD MMM, YYYY") : ""}</span>,
    },
    {
        title: "Status",
        dataIndex: "activityStatus",
        key: "activityStatus",
        width: 100,
        sorter: true,
        render: (text: string) => <p className={`status ${text}`}>{text?.replaceAll('_', ' ')}</p>,
    },
]

const sortFields: any = {
    "customer": "customer_name",
    "yardName": "yard_name",
    "containerOwnerName": "owner_name",
    "activityType": "activity_type_sort",
    "activityDate": "created_at",
    "activityStatus": "activity_status_sort",
}

const containerFilters = [
    'search_text',
    'page',
    'date',
    'activity_type',
    'activity_status',
    'yard_id',
    'customer_id',
]

export interface ContainerActivitiesInterface {
    rowClickHandler: (activity: Activity) => void
    formVisible: boolean
    isAdmin: boolean
}

const AllContainers = (props: ContainerActivitiesInterface) => {
    
    const [customerFilter, setCustomerFilter] = useState<number>();
    const [selectedRowKeys, setSelectedRows] = useState<number[]>([]);
    const [selectedRow, setSelected] = useState<Activity>();
    const [selectedRowsData, setSelectedRowsData] = useState<Activity[]>();


    const {
        rowClickHandler,
        formVisible,
        isAdmin,
    } = props

    const {
        loading,
        activities,
        fetchActivites,
        activitiesMeta,
    } = ContainerService()

    const {
        getParams,
        setParams,
    } = useFilters()
    
    const activityStatus= getParams(containerFilters)?.activity_status
  

    useEffect(() => {
        if (!formVisible)
            fetchAllActivities(getParams(containerFilters))
            const filters = getParams(containerFilters);
            setCustomerFilter(filters.customer_id || undefined);
    }, [formVisible])

    const fetchAllActivities = (options?: FormikValues) => {
        fetchActivites({
            status: ActivityEnum.ALL,
            ...options
        }, isAdmin ? UserTypes.ADMIN : UserTypes.CUSTOMER)
    }

    const filtersApplyHandler = (values: FormikValues) => {
      const customerId = values["customer_id"];
        setParams(values)
        setCustomerFilter(customerId);
        fetchAllActivities(values)
    }

    const handleTableChange = (pagination: any, filters: any, sorter: { field: any; order: any; }) => {
        const sortOrders = [undefined, 'ascend']
        const field = typeof sorter.field === 'string' ? sorter.field : sorter.field ? sorter.field[0] : undefined
        const params: any = {}
        params[sortFields[field]] = sortOrders.indexOf(sorter.order)
        params.page = pagination.current
        const repairListFilters = getParams(containerFilters)
        const updatedFilters = { ...repairListFilters, page: params.page }
        setParams(updatedFilters)
        fetchAllActivities({ ...params, ...updatedFilters })
    };
    
    
    const handleRowSelection = (selectedRowKeys: any[]) => {
    if (!selectedRowKeys.length || !selectedRow)
      setSelected(
        activities?.find((activity) => activity.id === selectedRowKeys[0])
      );
    setSelectedRows(selectedRowKeys);
      setSelectedRowsData(
    activities?.filter((a) => selectedRowKeys.includes(a?.id))
  );
  };

    return <Row gutter={[0, 20]}>
        <Col span={24}>
            <ContainerTableActions
                isAdmin={isAdmin}
                filtersApplyHandler={filtersApplyHandler}
                values={getParams(containerFilters)}
               activityStatus={activityStatus}
               isMaersk={
                          activities?.[0]?.customerType === CustomerType.MEARSK &&
                          !!selectedRowKeys.length
                        }
               selectedRowsData={selectedRowsData}
               selectedRowKeys={selectedRowKeys}
               
                
            />
        </Col>
        <Col span={24}>
            <TableComponent
                className="cursor-pointer"
                loading={loading}
                columns={columns}
                onChange={handleTableChange}
                data={activities}
                scroll={{ x: 700 }}
                handleRowClick={rowClickHandler}
                   rowSelection={
            customerFilter &&(activityStatus==ActivityStatusEnum.QUOTE_SENT_TO_CUSTOMER || activityStatus==ActivityStatusEnum.INVOICE_SENT_TO_CUSTOMER)
              ? {
                  selectedRowKeys,
                  onChange: handleRowSelection,
                }
              : undefined
          }
                pagination={{
                    pageSize: 20,
                    current: activitiesMeta?.current || 1,
                    total: activitiesMeta?.totalCount || 0,
                    showTotal: (total: number, range: [number, number]) => <p>Showing <b>{` ${range[0]} - ${range[1]}`}</b> of <b>{`${total.toLocaleString()}`}</b></p>
                }}
            />
        </Col>
    </Row>
}
export default (AllContainers)